import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ThemeProvider } from '@emotion/react';
import { BucketStrategy } from '@iotv/datamodel-core';
import { Box, TextField } from '@mui/material';
import { BarPlot, ChartsContainer, ChartsGrid, ChartsLegend, ChartsReferenceLine, ChartsTooltip, ChartsXAxis, ChartsYAxis, LinePlot, } from '@mui/x-charts';
import { useState } from 'react';
import { smallerInputTheme } from '../../cosmetics/Themes/MuiInputSmaller';
import { formatBucketedTimestamp } from '../../helpers/format';
/** Takes tabledata from a datagrid and translates it into a combo chart with google maps */
export const ComparisonChart = ({ data, timeParams, averageWindow }) => {
    console.log('Comparison Chart Data', data);
    const [yAxisMax, setYAxisMax] = useState(undefined);
    const updateYAxisMax = (newMax) => {
        if (newMax === '')
            setYAxisMax(undefined);
        else
            setYAxisMax(parseFloat(newMax));
    };
    // Perform averaging
    const avgCols = [];
    console.log('Averaging Columns', avgCols);
    console.log('Chart Rows', data.rows);
    const seriesColumns = [...data.columns.filter((c) => c.field != 'timestamp'), ...avgCols];
    const series = seriesColumns.map((col) => {
        //console.log(col);
        const serie = {
            dataKey: col.field,
            type: (col.bucketStrategy ?? BucketStrategy.APPORTION) == BucketStrategy.INFERREADING || col.average ? 'line' : 'bar',
            label: col.fullHeader,
        };
        return serie;
    });
    console.log('Comp Chart Series', series);
    return (_jsxs(Box, { sx: { width: '100%', height: '75vh' }, children: [_jsx(ThemeProvider, { theme: smallerInputTheme, children: _jsx(TextField, { value: yAxisMax, type: 'number', placeholder: "None", label: "Y Axis", onChange: (e) => {
                        updateYAxisMax(e.target.value);
                    } }) }), _jsxs(ChartsContainer, { dataset: data.rows, xAxis: [
                    {
                        dataKey: 'timestamp',
                        scaleType: 'band',
                        valueFormatter: (v) => {
                            return formatBucketedTimestamp(v, timeParams.bucketWidthMs, timeParams.fromDateValue.valueOf(), timeParams.toDateValue.valueOf());
                        },
                    },
                ], yAxis: [
                    {
                        min: undefined,
                        max: yAxisMax,
                        position: 'left',
                    },
                ], series: series, margin: { bottom: 110 }, children: [_jsx(BarPlot, {}), _jsx(LinePlot, {}), _jsx(ChartsReferenceLine, { y: 0 }), _jsx(ChartsGrid, { vertical: true, horizontal: true }), _jsx(ChartsXAxis, { position: "bottom", label: "Time" }), _jsx(ChartsYAxis, { position: "left", range: [{ min: 0, max: 150 }] }), _jsx(ChartsLegend, { direction: "horizontal" }), _jsx(ChartsTooltip, {})] })] }));
};
